import { apiClient, type PackageCategoryExEntity } from '@/libs/api'

export type FetchPackageCategoryQuery = {
  tenantKey: string
  packageCategoryId: number
}

/**
 * 荷姿一覧を取得（ページングなし）
 */
export const fetchPackageCategory = async (
  { tenantKey, packageCategoryId }: FetchPackageCategoryQuery,
  signal?: AbortSignal
): Promise<PackageCategoryExEntity> => {
  const { data } = await apiClient
    ._tenant(tenantKey)
    .package_categories._id(packageCategoryId)
    .$get({
      config: {
        signal
      }
    })
  return data
}
